<template>
    <input type="text"
           class="form-input"
           :value="value"
           @keyup="$emit('keyup', $event)"
           @input="onInput($event.target.value)"
           @change="$emit('change', $event.target.value)"
           @blur="$emit('blur')"
    >
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number],
            default: '',
        },

        capitalize: {
            type: [Boolean, String],
            default: false,
        },
    },

    methods: {
        onInput(newValue) {
            if (!this.capitalize) {
                this.$emit('input', newValue);
                return;
            }

            this.emitCapitalizedValue(newValue);
        },

        emitCapitalizedValue(newValue) {
            if (this.capitalizeMode === 'first') {
                this.$emit('input', newValue.charAt(0).toUpperCase() + newValue.slice(1));
            } else if (this.capitalizeMode === 'all') {
                this.$emit('input', newValue.toUpperCase());
            }
        },
    },

    computed: {
        capitalizeMode() {
            if (this.capitalize === true || this.capitalize === 'first') {
                return 'first';
            }

            if (this.capitalize === 'all') {
                return 'all';
            }

            return null;
        },
    },
};
</script>
